import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileEdit"><Path d="M4 2H12V10H20V22H8.2094L10.3083 19.9011V13.7088C10.3083 11.1407 8.22642 9.05884 5.65834 9.05884C5.07414 9.05884 4.51509 9.16657 4 9.36326V2Z" fill="currentColor"/><Path d="M14 2.58579L19.4142 8H14V2.58579Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 13.5588C3 12.1781 4.11929 11.0588 5.5 11.0588C6.88071 11.0588 8 12.1781 8 13.5588V19.4731L5.5 21.9731L3 19.4731L3 13.5588Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileEdit;
